module.exports = __webpack_public_path__ + "media/images/smart_phone/order_menu/btn_order-4a51e6fc53c0e37883381875772bff43.png";